import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { mojibakedFetch } from './app/graphql/httpLinks';
import client from './app/graphql/client';
import App from './app/App';

// Patch window.fetch globally — Apollo 3.x ignores createHttpLink `fetch` option.
// mojibakedFetch uses _realFetch captured at module load → no recursion.
window.fetch = mojibakedFetch as typeof window.fetch;

render(
  <BrowserRouter>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
